import { CALL_API, METHOD_TYPE } from '../../../middleware/api.middleware'

export const GET_FUND_PURCHASING_POWER_REQUEST = 'GET_FUND_PURCHASING_POWER_REQUEST'
export const GET_FUND_PURCHASING_POWER_SUCCESS = 'GET_FUND_PURCHASING_POWER_SUCCESS'
export const GET_FUND_PURCHASING_POWER_FAILURE = 'GET_FUND_PURCHASING_POWER_FAILURE'
export const RESET_FUND_PURCHASING_POWER = 'RESET_FUND_PURCHASING_POWER'

/**
 * Get Purchasing Power
 * @param factsetEntityId
 * @param securityId
 * @param options
 * @private
 */
const _fetchFundPurchasingPower = ({ factsetEntityId, securityId }, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      GET_FUND_PURCHASING_POWER_REQUEST,
      GET_FUND_PURCHASING_POWER_SUCCESS,
      GET_FUND_PURCHASING_POWER_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: `/purchasingpower/fund/${factsetEntityId}`,
    payload: {
      securityId
    }
  }
})

/**
 * Get Purchasing Power
 * @param params
 * @param options
 */
export const fetchFundPurchasingPower = (params, options) => (dispatch) => {
  return dispatch(_fetchFundPurchasingPower(params, options))
}

/**
 * Clean Purchasing Power
 * @return {function(*): *}
 */
export const cleanFundPurchasingPower = () => (dispatch) => {
  return dispatch({ type: RESET_FUND_PURCHASING_POWER })
}
